import { isSameMonth } from "date-fns";
import LargeMonthViewEventChip from "./LargeMonthViewEventChip";
import LargeMonthViewNumbers from "./LargeMonthViewNumbers";
function classNames(...classes) {return classes.filter(Boolean).join(' ')}

const LargeMonthViewCalendar = ({dayObject, firstDayOfCurrentMonth, setEditEvent, setEventToEdit, setSelectedDay, setView, createNewCalendarEvent}) => {

    const goToDayView = (day) => {
      setSelectedDay({date: day, events: [], availabilities: []})
      setView('Day view')
    }

    const findTotalOfRealLessonEvents = (day) => {
      let totalLessonEvents = 0
      for(let i = 0; i < dayObject[day].events.length; i++) {
        if(!dayObject[day].events[i].isPendingOffer){
          totalLessonEvents++
        }
      }
      return totalLessonEvents
    }

    const checkForPendingOffers = (day) => {
      let pendingOffers = 0
      for(let i = 0; i < dayObject[day].events.length; i++) {
        if(dayObject[day].events[i].isPendingOffer){
          pendingOffers++
        }
      }
      return pendingOffers
    }

    const returnTimezoneSafeDateObject = (day) => {
      const [year, month, date] = day.split('-').map(Number);
      const newDate = new Date(year, month - 1, date);
      return newDate
    }

    const createDateObjectAndAddHours = (date) => {
      let e = returnTimezoneSafeDateObject(date)
      e.setHours(18)
      return e
    }

    return(
        <div className="calendar__large-month-grid">
          {Object.keys(dayObject).map((day) => (
            <div key={day} onClick={(e) => (e.target.id !== 'date-number' && e.target.id !== 'existing-event') && createNewCalendarEvent(createDateObjectAndAddHours(day))} className={classNames(isSameMonth(returnTimezoneSafeDateObject(day), firstDayOfCurrentMonth) ? 'is-current-month' : 'is-outside-month', 'calendar__month-day')}>
              <div>
                <LargeMonthViewNumbers day={day} goToDayView={goToDayView} />
                {checkForPendingOffers(day) > 0 && <div className="absolute top-1 right-1 w-4 h-4 bg-orange-500 rounded-full text-white text-xs flex justify-center items-center">{checkForPendingOffers(day)}</div>}
              </div>
              {dayObject[day].events.length > 0 && (
                <ol className="mt-2">
                  {dayObject[day].events.slice(0, 2).map((event) => !event.isPendingOffer && <LargeMonthViewEventChip key={event.id} event={event} setEditEvent={setEditEvent} setEventToEdit={setEventToEdit} />)}
                  {findTotalOfRealLessonEvents(day) > 2 && <li id="existing-event" onClick={() => goToDayView(returnTimezoneSafeDateObject(day))} className="calendar__month-more-events">{findTotalOfRealLessonEvents(day) - 2} more…</li>}
                </ol>
              )}
            </div>
          ))}
        </div>
    )
}
export default LargeMonthViewCalendar;
